import Vue from 'vue'
import VueWaypoint from 'vue-waypoint'
import App from './App.vue'

Vue.use(VueWaypoint);

Vue.config.productionTip = false

const yddvizApp = {
  onMount: () => {
    new Vue({
      render: h => h(App)
    }).$mount('#app-2021-11-inkomstgrupper_fi')
  }
};

yddvizApp.projectName = 'app-2021-11-inkomstgrupper_fi';

if (window.yleVisualisationEmbeds === undefined) {
  window.yleVisualisationEmbeds = {};
}
if (window.yleVisualisationEmbeds[yddvizApp.projectName] === undefined) {
  window.yleVisualisationEmbeds[yddvizApp.projectName] = yddvizApp;
  window.yleVisualisationEmbeds[yddvizApp.projectName].onMount();
}
